<template>
  <div class="d-flex justify-center align-center" style="height: 100%">
    <div class="text-center">
      <v-img src="@/assets/img/success.png" style="width: 137px; height: 107px; margin: 0 auto"></v-img>
      <p style="font-size: 40px">{{ makeRub(balance_free) }}</p>
      <p>Деньги поступят в течение 3 рабочих дней</p>
      <v-btn large depressed class="mt-4" @click="closeWithdrawal">Отлично</v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { makeRub } from "@/mixins/makeRub";

export default {
  mixins: [makeRub],
  computed: {
    ...mapState("billing", ["balance_free"]),
  },
  methods: {
    closeWithdrawal() {
      this.$store.commit("billing/showWithdrawalSidePanel", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.settings {
  width: 900px;
  position: fixed;
  right: 0px;
  top: 0;
  bottom: 0;
  z-index: 100;
}

@media (max-width: 600px) {
  .form {
    margin-top: 60px;
  }
}
@media (max-width: 1904px) and (min-width: 640px) {
  .form {
    margin: 25%;
  }
}
</style>
